import { sendCommand } from './traccar-api';

const DEFAULT_WEBRTC_BASE_URL = 'https://media.n-gps.com';
const DEFAULT_RTMP_URL = 'rtmp://media-ip.n-gps.com:1936/live';

function getSettings() {
  try {
    const s = JSON.parse(localStorage.getItem('app_settings') ?? '{}');
    return {
      webrtcBaseUrl: (s.jimiWebrtcBaseUrl || DEFAULT_WEBRTC_BASE_URL).replace(/\/$/, ''),
      rtmpUrl: (s.jimiRtmpUrl || DEFAULT_RTMP_URL).trim(),
    };
  } catch {
    return {
      webrtcBaseUrl: DEFAULT_WEBRTC_BASE_URL,
      rtmpUrl: DEFAULT_RTMP_URL,
    };
  }
}

export function getJimiWhepUrl(imei: string, channel: number): string {
  const { webrtcBaseUrl } = getSettings();
  return `${webrtcBaseUrl}/rtc/live/${channel}/${imei}/whep`;
}

export async function startJimiStreaming(deviceId: number, _channel: number): Promise<void> {
  const { rtmpUrl } = getSettings();
  await sendCommand({ deviceId, type: 'custom', textChannel: false, attributes: { data: `RSERVICE,${rtmpUrl}` } });
  await sendCommand({ deviceId, type: 'custom', textChannel: false, attributes: { data: 'RTMP,ON,INOUT' } });
}

const UPLOAD_FUNCTION_URL = 'https://ncaqkjpxwmufscronbpk.supabase.co/functions/v1/jimi-upload/upload';

export async function configureJimiUpload(deviceId: number): Promise<void> {
  await sendCommand({ deviceId, type: 'custom', textChannel: false, attributes: { data: `UPLOAD,${UPLOAD_FUNCTION_URL}` } });
}

export async function requestJimiVideoUpload(deviceId: number, channel: number, seconds = 5): Promise<void> {
  const camera = channel === 1 ? 'in' : 'out';
  await sendCommand({ deviceId, type: 'custom', textChannel: false, attributes: { data: `Video,${camera},${seconds}s` } });
}

export async function requestJimiSdCardFileList(deviceId: number): Promise<void> {
  await sendCommand({ deviceId, type: 'custom', textChannel: false, attributes: { data: `FILELIST,${UPLOAD_FUNCTION_URL}` } });
  await sendCommand({ deviceId, type: 'custom', textChannel: false, attributes: { data: 'FILELIST' } });
}

export async function requestJimiHistoryVideoUpload(deviceId: number, filename: string): Promise<void> {
  const match = filename.match(/^(\d{4}_\d{2}_\d{2}_\d{2}_\d{2}_\d{2})_(\d+)\.mp4$/i);
  if (!match) throw new Error('Invalid Jimi history video filename');
  const [, timestamp, channel] = match;
  await sendCommand({ deviceId, type: 'custom', textChannel: false, attributes: { data: `HVIDEO,${timestamp},${Number(channel)}` } });
}
